import { ArrowRight } from "lucide-react";
import { FadeIn } from "./FadeIn";

const CALENDLY = "https://calendly.com/katie-fernands/discovery-call";

const before = [
  "Referrals come in unpredictable waves",
  "LinkedIn feels like an obligation, not an asset",
  "Cold outreach that no one wants to send or receive",
  "Growth depends on your personal bandwidth",
];

const after = [
  "A steady pipeline of warm, qualified prospects",
  "LinkedIn becomes a real growth channel",
  "Outreach that feels like a conversation, not a pitch",
  "Growth that keeps running when you step away",
];

export function BeforeAfter() {
  return (
    <section className="grid md:grid-cols-2 min-h-[80vh]">
      {/* Before — muted cream half */}
      <div className="bg-surface-muted text-foreground px-6 lg:px-16 py-24 md:py-32 flex flex-col justify-center">
        <FadeIn className="max-w-md md:ml-auto md:mr-16">
          <div className="flex items-baseline gap-3 mb-10">
            <span className="text-xs uppercase tracking-[0.28em] text-foreground/50">Before</span>
            <span className="h-px flex-1 bg-foreground/20" />
          </div>
          <h2 className="text-3xl md:text-4xl leading-[1.1] tracking-tight mb-12 text-foreground/70">
            Hoping for referrals.
          </h2>
          <ul className="space-y-6">
            {before.map((b, i) => (
              <li key={b} className="flex gap-5 text-base text-foreground/55">
                <span className="font-serif text-xs text-foreground/35 pt-1.5 w-6 flex-none">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="line-through decoration-foreground/25 leading-relaxed">{b}</span>
              </li>
            ))}
          </ul>
        </FadeIn>
      </div>

      {/* After — forest half */}
      <div className="bg-dark text-on-dark px-6 lg:px-16 py-24 md:py-32 flex flex-col justify-center">
        <FadeIn delay={0.15} className="max-w-md md:mr-auto md:ml-16">
          <div className="flex items-baseline gap-3 mb-10">
            <span className="text-xs uppercase tracking-[0.28em] text-primary">After</span>
            <span className="h-px flex-1 bg-primary/40" />
          </div>
          <h2 className="text-3xl md:text-4xl leading-[1.1] tracking-tight mb-12 text-white">
            Running an <em className="italic text-primary">engine.</em>
          </h2>
          <ul className="space-y-6">
            {after.map((a, i) => (
              <li key={a} className="flex gap-5 text-base text-white/90">
                <span className="font-serif text-xs text-primary pt-1.5 w-6 flex-none">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="leading-relaxed">{a}</span>
              </li>
            ))}
          </ul>

          <a
            href={CALENDLY}
            target="_blank"
            rel="noopener noreferrer"
            className="group mt-12 inline-flex items-center gap-2 text-sm text-white/70 hover:text-white transition-colors border-b border-white/20 hover:border-white pb-1"
          >
            Build your engine with a 30-minute call
            <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
          </a>
        </FadeIn>
      </div>
    </section>
  );
}
